routerConfig.$inject = ['$routeProvider'];

export default function routerConfig ($routeProvider) {
	'ngInject';
	$routeProvider
		.when('/', {
			templateUrl: '/app/home.html'
		})
		.when('/artikel/lager', {
			templateUrl: '/app/artikel/lager.html'
		})
		.when('/artikel/:id', {
			templateUrl: '/app/artikel/artikel.html'
		})
		.when('/iso14726', {
			templateUrl: '/app/artikel/iso14726.html'
		})
		.when('/anfragen/:id', {
			templateUrl: '/app/anfragen/anfrage.html'
		})
		.when('/requestQuote', {
			templateUrl: '/app/artikel/requestQuote.html'
		})
		.when('/requestQuoteSuccess', {
			templateUrl: '/app/artikel/requestQuoteSuccess.html'
		})
		.when('/kunden', {
			templateUrl: '/app/kunden/kunden.html'
		})
		.when('/kunden/:id', {
			templateUrl: '/app/kunden/kunde.html'
		})
		.when('/kontakt', {
			templateUrl: '/app/kontakt/kontakt.html'
		})
		.when('/rechnungen', {
			templateUrl: '/app/rechnungen/rechnungen.html'
		})
		.when('/rechnungen/neu', {
			templateUrl: '/app/rechnungen/rechnungNeu.html'
		})
		.when('/rechnungen/:id', {
			templateUrl: '/app/rechnungen/rechnung.html'
		})
		.when('/login', {
			templateUrl: '/app/login/login.html'
		})
		.otherwise({
			redirectTo: '/'
		});
}



/** WEBPACK FOOTER **
 ** ./public/app/index.route.js
 **/